import React, { useState, useEffect } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { Flex } from '@chakra-ui/core';
import Modal from 'react-modal';

import { colors } from '../../styles/theme';
import Close from '../../assets/Close';
import GetStarted from '../ModalPortal/GetStarted';
import SeeMore from '../ModalPortal/SeeMore';
import CombiningFinancesGuide from '../ModalPortal/CombiningFinancesGuide';
import LoginModal from '../ModalPortal/LoginModal';

const GetStartedModal = ({ newsletterOnly = false }) => {
  const [showNewsletter, setShowNewsletter] = useState(newsletterOnly);
  const { modalOpen } = useStoreState(state => state.modalDisplay);
  const { closeModal } = useStoreActions(actions => actions.modalDisplay);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1080
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', setWindowWidth(window.innerWidth));
    }
  });

  const mobileView = windowWidth < 640;

  let maxWidth = modalOpen === 'get-started' || modalOpen === 'login' ? '40rem' : '60rem';
  if (mobileView) maxWidth = '100%';

  const modalStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.58)',
      zIndex: 5
    },
    content: {
      zIndex: 1,
      position: 'relative',
      top: mobileView ? 0 : '80px',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      margin: mobileView ? '0' : '32px auto',
      padding: 0,
      border: 0,
      maxWidth: maxWidth,
      maxHeight: mobileView ? '100%' : 'auto',
      overflow: 'scroll'
    }
  };

  const close = () => {
    setShowNewsletter(showNewsletter);
    closeModal();
  };

  const ModalContent = () => {
    if (modalOpen === 'get-started') {
      return <GetStarted />;
    } else if (modalOpen === 'seeMore') {
      return <SeeMore />;
    } else if (modalOpen === 'combining-finances-guide') {
      return <CombiningFinancesGuide />;
    } else if (modalOpen === 'login') {
      return <LoginModal />;
    } else {
      return <p />;
    }
  };

  const bgColor =
    modalOpen === 'combining-finances-guide' ? colors.tan : colors.lightestPrimary;
  return (
    <Modal
      isOpen={modalOpen ? true : false}
      onRequestClose={close}
      style={modalStyles}
      contentLabel="Get Started"
      ariaHideApp={false}
    >
      <Flex direction="column" px={6} py={6} backgroundColor={bgColor}>
        <Flex justify="flex-end">
          <Flex cursor="pointer" onClick={close}>
            <Close />
          </Flex>
        </Flex>
        <ModalContent />
      </Flex>
    </Modal>
  );
};

export default GetStartedModal;
